import { getContentDispositionFilename } from '@/utils/parseHeader';
import { ImageSize } from '@/config/ImageSize';
import { ImageFormat } from '@/config/ImageFormat';
import request from './request';

export default {
  getStaffAvailableQrCodes: ({ locationId, staffId }) => request.easytip({
    method: 'get',
    url: `/v5/qrcheckin/workplaces/${locationId}/staffs/${staffId}/codes/available`,
  }),
  grantStaffQrCodes: ({ locationId, staffId, codes }) => request.easytip({
    method: 'post',
    url: `/v5/qrcheckin/workplaces/${locationId}/staffs/${staffId}/codes/grant`,
    data: codes,
  }),
  searchCodes: ({
    workplaceId,
    name = '',
    start = 0,
    pageSize = 10,
  }) => request.easytip({
    method: 'get',
    url: `/v5/qrcheckin/workplaces/${workplaceId}/codes/search`,
    params: {
      name,
      start,
      pageSize,
    },
  }),
  getCodeQr: ({
    workplaceId,
    codeId,
    type = ImageFormat.SVG,
    quality = ImageSize.BIG,
  }) => request.easytip({
    method: 'get',
    url: `/v5/qrcheckin/workplaces/${workplaceId}/codes/${codeId}/qr`,
    params: {
      type,
      quality,
    },
    headers: {
      Accept: '*/*',
    },
    responseType: 'blob',
  }).then((res) => ({
    data: res.data,
    filename: getContentDispositionFilename(res.headers),
  })),
  downloadCodesZip: ({
    workplaceId,
    ids = [],
    all = false,
    type = ImageFormat.SVG,
    quality = ImageSize.BIG,
  }) => request.easytip({
    method: 'post',
    url: `/v5/qrcheckin/workplaces/${workplaceId}/codes/download`,
    params: {
      type,
      quality,
    },
    data: {
      ids,
      all,
    },
    headers: {
      Accept: '*/*',
    },
    responseType: 'blob',
  }).then((res) => ({
    data: res.data,
    filename: getContentDispositionFilename(res.headers),
  })),
};
